
import { Box, Button, Grid, Paper, useTheme } from '@mui/material';
import React from 'react';
import HomePicture from '../assets/HomeKhang.jpg';
import { useSetAtom } from 'jotai';
import { lensAtom } from '../components/NavBar';

const Home = () => {
    const selectPageLens = useSetAtom(lensAtom);
    return (
        <React.Fragment>
            <Paper sx={{ padding: '1.5em' }} elevation={0.75}>
                <Grid size={1}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1.5em' }}>
                        <img src={HomePicture} style={{
                            borderRadius: "50%", width: '25em', maxWidth: '100%', padding: '0.3em',
                            borderStyle: 'solid',
                            borderWidth: '.3em'
                        }} />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box sx={{ maxWidth: '1000px', marginBottom: '1em' }}>
                            Hello! I'm Khang Nguyen, a Software Developer based in Ottawa with a strong focus on building scalable, data-driven solutions. I hold a BASc in Software Engineering from the University of Ottawa and have professional experience at companies like Veeva Systems, Amazon, SSENSE, Interac, and NetFore Systems. My work has primarily centered around event-driven and RESTful architectures, with deep experience deploying and scaling both serverless applications and Kubernetes workloads. I specialize in full-stack development, cloud infrastructure, and system design, and I enjoy turning complex technical challenges into intuitive, high-impact software.
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Button variant="contained" onClick={() => selectPageLens('experience')}>Learn More</Button>
                    </Box>
                </Grid>
            </Paper>
        </React.Fragment>
    );
}

export default Home;
